import React, { useState } from 'react';

import { Button } from 'components/ui/button';
import { Card, CardContent } from 'components/ui/card';
import {
  CustomRadarChart,
  DEFAULT_RADAR_CHART_DEFINITION_KEY,
} from '../../components/RadarChart';
import { PaceReport } from '../../components/PaceReport';

type ReportType = 'progress' | 'pace';

export const Reports: React.FC = () => {
  const [reportType, setReportType] = useState<ReportType>('progress');

  return (
    <div className="space-y-6 px-6 py-10">
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="text-3xl font-semibold text-foreground">Reports</h1>
        <div className="flex gap-2 rounded-full border border-white/10 bg-white/5 p-1">
          <Button
            type="button"
            size="auto"
            variant={reportType === 'progress' ? 'default' : 'secondary'}
            className={`rounded-full px-6 py-2 text-sm transition ${reportType === 'progress' ? 'bg-gradient-to-r from-primary to-secondary text-white hover:from-primary/85 hover:to-secondary/85' : 'bg-transparent text-white/80 hover:bg-white/10 hover:text-white'}`}
            onClick={() => setReportType('progress')}
          >
            Progress
          </Button>
          <Button
            type="button"
            size="auto"
            variant={reportType === 'pace' ? 'default' : 'secondary'}
            className={`rounded-full px-6 py-2 text-sm transition ${reportType === 'pace' ? 'bg-gradient-to-r from-primary to-secondary text-white hover:from-primary/85 hover:to-secondary/85' : 'bg-transparent text-white/80 hover:bg-white/10 hover:text-white'}`}
            onClick={() => setReportType('pace')}
          >
            Pace
          </Button>
        </div>
      </div>

      {reportType === 'progress' ? (
        <Card className="border-white/10 bg-white/5 shadow-lg">
          <CardContent className="space-y-4">
            <h2 className="text-lg font-semibold text-foreground">Category Progress Overview</h2>
            <div className="h-[400px]">
              <CustomRadarChart definitionKey={DEFAULT_RADAR_CHART_DEFINITION_KEY} />
            </div>
          </CardContent>
        </Card>
      ) : (
        <Card className="border-white/10 bg-white/5 shadow-lg">
          <CardContent className="space-y-4">
            <h2 className="text-lg font-semibold text-foreground">User Pace Analysis</h2>
            <div className="h-[400px]">
              <PaceReport />
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default Reports;
